"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargebackStatus = void 0;
var ChargebackStatus;
(function (ChargebackStatus) {
    ChargebackStatus[ChargebackStatus["Pending"] = 0] = "Pending";
    ChargebackStatus[ChargebackStatus["Fulfilled"] = 1] = "Fulfilled";
    ChargebackStatus[ChargebackStatus["Failed"] = 2] = "Failed";
})(ChargebackStatus || (exports.ChargebackStatus = ChargebackStatus = {}));
//# sourceMappingURL=ChargebackStatus.js.map